import angular from 'angular';
import $ from 'jquery';

export default class UserProductPricings {
  constructor($scope, $rootScope, UserProductService) {
    $scope.pricing_tabs = [
      {
        title: 'CFR',
        delivery_term_id: 1
      },
      {
        title: 'FCA',
        delivery_term_id: 3
      },
      {
        title: 'DAP',
        delivery_term_id: 2
      },
      {
        title: 'FOB',
        delivery_term_id: 5
      }
    ];

    $scope.load_pricings = function() {
      $scope.loading = true;
      UserProductService.get_user_products_pricings(window.user_id).then(function(data) {
        $scope.user_products = data.user_products;
        $scope.loading = false;
        $scope.set_product_pricings();
      });
    };

    $scope.set_product_pricings = function() {
      var count = 0;
      angular.forEach($scope.user_products, function(p) {
        if (p.has_pricings)
          count++;
      });
      var percentage = Math.floor(count / $scope.user_products.length * 100.0);
      $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 0 : 1, window.is_buyer ? 6 : 5, [{
        type: 'counter',
        value: count
      }, {
        type: 'percentage',
        value: percentage
      }]]);
    };

    $scope.set_pricings_selected_tab = function(index) {
      $scope.pricings_selected_tab = index;
    };

    $scope.edit_pricings = function(user_product_id) {
      $scope.set_pricings_selected_tab(0);
      var dialog = $('div#edit_pricings_dialog');
      $.fancybox(dialog, {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'yes',
        afterShow: function() {
          UserProductService.get_user_product_pricings(user_product_id).then(function(data) {
            $scope.dialog_user_product = data.user_product;
          });
        },
        afterClose: function() {
          $scope.dialog_user_product = null;
          $scope.user_products = [];
          $scope.load_pricings();
        }
      });
    };

    $scope.add_product_row = function(delivery_term_id) {
      var pricing = {
        user_product_pricing: angular.copy(window.product_pricing)
      };
      pricing.user_product_pricing.user_product_id = $scope.dialog_user_product.id;
      pricing.user_product_pricing.delivery_term_id = delivery_term_id;
      $scope.dialog_user_product.pricings.push(pricing);
    };

    $scope.add_product_brand_row = function(brand, delivery_term_id) {
      var pricing = {
        user_product_brand_pricing: angular.copy(window.product_brand_pricing)
      };
      pricing.user_product_brand_pricing.user_product_brand_id = brand.id;
      pricing.user_product_brand_pricing.delivery_term_id = delivery_term_id;
      brand.pricings.push(pricing);
    };

    $scope.save_pricings = function() {
      $scope.saving_pricings = true;
      UserProductService.save_pricings($scope.dialog_user_product).then(function() {
        $scope.saving_pricings = false;
      });
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.load_pricings();
    };

    $scope.init();
  }
}

UserProductPricings.$inject = ['$scope', '$rootScope', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-pricings.ctrl.js